module.exports = __webpack_public_path__ + "img/small-4.93ca27eb.webp";